import AppDispatcher from '../../../../flux/dispatcher/dispatcher';
import Constant from '../constant/LineChartConstant';
import restClient from '../../../../routers/MainFrame/action/APIClient';
import LogoutConstant from '../../../../routers/MainFrame/constants/Constants';

import urlConfig from '../../../../config/index';
var moment = require('moment');
var _ = require("lodash");
var organization, country, locality, area, profileId, granularity = 'weekly';
var dateRange = {}, filters = {};

var LineChartAction = function () {

}

LineChartAction.prototype = {

	clearFilters: function () {
		filters = {};
		organization = "";
		country = undefined;
		locality = undefined;
		area = undefined;
		granularity = 'weekly';
	},

	addDownloadFilters: function (data) {
		filters = _.cloneDeep(data);
		if (filters.profileId) {
			profileId = filters.profileId;
			delete filters.profileId
		}
		if (data.granularity) {
			granularity = data.granularity;
			// delete data.granularity;
		}
		this.loadData();
	},

	addFilters: function (data, newGranularity) {
		filters = data;
		granularity = newGranularity;
		this.loadData();
	},

	changeProfile: function (value) {
		profileId = value;
		this.loadData();
	},

	// clearFilters: function () {
	// 	organization = "";
	// 	country = undefined;
	// 	locality = undefined;
	// 	area = undefined;
	// 	granularity = 'weekly';
	// },

	changeOrganisation: function (value) {
		organization = value;
		this.loadData();
	},

	addCountry: function (value) {
		country = value;
		locality = undefined;
		area = undefined;
		this.loadData()
	},

	addArea: function (value) {
		area = value;
		locality = undefined;
		this.loadData();
	},

	addLocality: function (value) {
		locality = value;
		this.loadData();
	},

	addDates: function (fromDate, toDate) {
		dateRange.from = fromDate;
		dateRange.to = toDate;
		this.loadData();
	},

	changeGranularity: function (value) {
		granularity = value;
		this.loadData();
	},

	loadData: function () {
		if (!(filters.hasOwnProperty('dateRange'))) {
			dateRange.from = moment().subtract(16, 'week').format('YYYY-MM-DD');
			dateRange.to = moment().format('YYYY-MM-DD');
			filters['dateRange'] = dateRange;
		}

		filters['insightFilters'] = {
			"metrics": [
				"ACTIONS_DRIVING_DIRECTIONS",
				"ACTIONS_PHONE",
				"ACTIONS_WEBSITE"
			]
		}
		var data = {
			profileId: localStorage.getItem('profileId'),
			granularity: granularity,
			filters: filters
		};


		restClient.getLocationInsightHistogram(data, function (error, response) {
			if (error) {
				// console.log("error", error);
				if (error.status === 401) {
					AppDispatcher.dispatch({
						actionType: LogoutConstant.UNAUTHORIZED_EXCEPTION,
						data: error
					});
				}
			} else {
				AppDispatcher.dispatch({
					actionType: Constant.LINE_CHART,
					data: response
				});
			}

		})
	},
	downloadReviewLocation() {
		var urlName = urlConfig.urlName;
		var data = {
			profileId: localStorage.getItem('profileId'),
			granularity: granularity,
			domainName: urlName,
			filters: filters
		};
		filters['insightFilters'] = {
			"metrics": [
				"ACTIONS_DRIVING_DIRECTIONS",
				"ACTIONS_PHONE",
				"ACTIONS_WEBSITE"
			]
		}
		restClient.getLocationInsightHistogramCsv(data, function (error, response) {
			if (error) {
				// console.log("error", error);
				if (error.status === 401) {
					AppDispatcher.dispatch({
						actionType: LogoutConstant.UNAUTHORIZED_EXCEPTION,
						data: error
					});
				}
			} else {

				AppDispatcher.dispatch({
					actionType: Constant.LINE_CHART_CSV,
					data: response
				});
			}

		})
	},
	universalDownloader() {
		var urlName = urlConfig.urlName;
		var data = {
			profileId: localStorage.getItem('profileId'),
			granularity: granularity,
			domainName: urlName,
			filters: filters
		};
		filters['insightFilters'] = {
			"metrics": [
				"QUERIES_DIRECT", "QUERIES_INDIRECT","QUERIES_CHAIN", "VIEWS_MAPS", "VIEWS_SEARCH", "ACTIONS_WEBSITE", "ACTIONS_DRIVING_DIRECTIONS",
				"ACTIONS_PHONE", "DRIVING_DIRECTIONS_PERCENT", "PHONE_PERCENT", "WEBSITE_PERCENT", "PHOTOS_VIEWS_MERCHANT", "PHOTOS_COUNT_MERCHANT", "PHOTOS_VIEWS_CUSTOMERS", "PHOTOS_COUNT_CUSTOMERS",
				"BUSINESS_IMPRESSIONS_DESKTOP_MAPS", "BUSINESS_IMPRESSIONS_MOBILE_MAPS","BUSINESS_IMPRESSIONS_MOBILE_SEARCH","BUSINESS_IMPRESSIONS_DESKTOP_SEARCH"
			]
		}
		restClient.getLocationInsightHistogramCsv(data, function (error, response) {
			if (error) {
				// console.log("error", error);
				if (error.status === 401) {
					AppDispatcher.dispatch({
						actionType: LogoutConstant.UNAUTHORIZED_EXCEPTION,
						data: error
					});
				}
			} else {
				AppDispatcher.dispatch({
					actionType: Constant.UNIVERSAL_INSIGHT_CSV,
					data: response
				});
			}
		})
	}
}

export default new LineChartAction();
